import type { FaireProductEntity } from "../../entity_types/product";

export const p_c2z428vbsh: FaireProductEntity = {
  token: "p_c2z428vbsh",
  type: "product",
  name: "Softies x The Fill All Day Wash™ Laundry Detergent",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/3cf62197acad43b8217af98b34bc3f3cf02e3e2e2b481c5146d2911879fb1c80.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4710c7e8ef9acd5b5fc8b2ee59ef3fbd27dfefbc5863642e87c9568884a0d756.png",
    "https://cdn.faire.com/fastly/4128ab33523834e105a738f4e622e20fd103414fa08a8619468d525d9a8f2c43.png",
    "https://cdn.faire.com/fastly/73c68e0ff07534b5cc6c382858e46a5b7920051866ede3797b55fd42a2b400c2.png",
    "https://cdn.faire.com/fastly/f5dc8d44d49bcc551ed012dd41295fc814bf1a5775eee8fa28b5946bc0d0436b.png"
  ],
  priceDollars: 15,
  description: "Created to infuse Softies softness into every load, this highly concentrated all-purpose detergent brightens, preserves color, and increases softness while removing stains and odor.\n\nPlant-Based Materials • Vegan • Free From Harmful Chemicals • Cruelty-Free\n\nSAFETY SHEET\n\nCALIFORNIA CLEANING PRODUCT RIGHT TO KNOW DISCLOSURE\n",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:12.862Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
